module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Administrative form")]), _vm._v(" "), (_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('user-form', {
    ref: "userForm",
    attrs: {
      "questions": _vm.questions,
      "values": _vm.values,
      "error-messages": _vm.errorMessages
    }
  }) : _c('div', [_vm._v("\n    Update the webpage ...\n  ")]), _vm._v(" "), (_vm.userFormHasError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    Complete the form before paying\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickValidate()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07bf94a3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutForm.vue
// module id = 724
// module chunks = 3